export const BASE_HIGHLIGHTS_TO_SHOW = 10;
export const HIGHLIGHTS_TO_SHOW = 5;
